/*
 * Copyright (c) 2017 Datarista, Inc.
 */

export const getClassName = (touched, error) => {
  if (touched && !error) {
    return 'form-group has-success';
  }
  if (touched && error) {
    return 'form-group has-danger';
  }
  return 'form-group';
};

export const checkButtonDisabled = (invalid, submitting) => {
  if (submitting) return true;
  if (invalid) return true;
  return false;
};
